import { useModal } from '@ebay/nice-modal-react'
import { useEffect, useRef } from 'react'

import { AnnouncementModal } from '../components/common'
import useNotices from './queries/useNotices'

const STORAGE_KEY = 'announcements'
const MAX_REMEMBERED = 50

const readSeen = (): string[] => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY)
    if (!stored) return []
    const parsed: unknown = JSON.parse(stored)
    return Array.isArray(parsed)
      ? parsed.filter((x): x is string => typeof x === 'string')
      : []
  } catch {
    return []
  }
}

const markSeen = (id: string) => {
  const next = [...readSeen().filter(x => x !== id), id].slice(-MAX_REMEMBERED)
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next))
  } catch {
    // Safari private mode / quota exceeded — worst case the user re-sees
    // this announcement next session.
  }
}

const useAnnouncements = () => {
  const announcementModal = useModal(AnnouncementModal)
  const { data } = useNotices()
  // The popup is a once-per-load side effect; guard against later refetches
  // of the shared notices query re-triggering it.
  const attempted = useRef(false)

  useEffect(() => {
    if (!data || attempted.current) return
    attempted.current = true

    const seen = readSeen()
    const popupAnnouncement = data.find(
      announcement =>
        announcement.is_popup === '1' && !seen.includes(announcement.id),
    )
    if (!popupAnnouncement) return

    announcementModal.show({
      announcement: popupAnnouncement,
      onClose: () => markSeen(popupAnnouncement.id),
    })
  }, [data])
}

export default useAnnouncements
